import { Link } from "react-router-dom";
import { BRAND, brandName } from "@/branding.config";

/**
 * Brand logo — reads mark + wordmark from the central branding config.
 * If BRAND.logo is an image URL that exists, it is rendered; otherwise the
 * built-in SVG mark + two-tone wordmark is used.
 */
export default function Logo({ size = "md", withText = true, to = "/" }) {
  const px = size === "sm" ? "text-lg" : size === "lg" ? "text-3xl" : "text-xl";
  const { first, second } = brandName();

  return (
    <Link
      to={to}
      data-testid="brand-logo"
      aria-label={BRAND.app_name}
      className="flex items-center gap-2.5 font-display font-black tracking-tight select-none"
    >
      <span
        className="relative inline-flex h-9 w-9 items-center justify-center rounded-2xl text-white"
        style={{
          background: `linear-gradient(135deg, ${BRAND.primary_color} 0%, ${BRAND.secondary_color} 50%, ${BRAND.accent_color} 100%)`,
          boxShadow: `0 8px 30px -8px ${BRAND.primary_color}99`,
        }}
      >
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">
          <path d="M4 6l6 12 4-8 6 8" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
      {withText && (
        <span className={px}>
          {first}
          <span className="brand-gradient-text">{second}</span>
        </span>
      )}
    </Link>
  );
}
